export const getDomain = () => window.location.hostname
